// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index-container[data-v-2b35618c]{display:flex;flex-direction:column;width:100%}.checklist-height[data-v-2b35618c]{height:700px}@media (max-width:768px){.checklist-height[data-v-2b35618c]{height:auto;padding-bottom:50%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
